var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Watch } from 'vue-property-decorator';
import { getVideosCRM } from '@/shared/utils/Infosets.utils';
import { NotificationService } from '@/services/NotificationService';
import { verifyAgendorToken } from '@/clients/crm';
import Modal from 'components/Modal.vue';
import Tooltip from 'components/Tooltip.vue';
import CrmCardContent from 'components/CrmCardContent.vue';
let AgendorConfigCard = class AgendorConfigCard extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.token = '';
        this.tokenVerified = false;
        this.ocultedToken = true;
        this.openModal = false;
        this.crmIcon = 'statics/images/logos/agendor-logo.svg';
        this.companyFields = [
            'Razão Social/Nome Fantasia',
            'Endereço',
            'Situação',
            'CNPJ',
            'Setor',
            'Cnae Primário',
            'Cnae Secundário',
            'Data de Abertura',
            'Faixa de Faturamento da Unidade CNPJ',
            'Faixa de Faturamento da Empresa',
            'Faixa de Funcionários da Unidade CNPJ',
            'Faixa de Funcionarios da Empresa',
            'Natureza Jurídica',
            'Administrador',
            'Facebook',
            'Website',
            'Todos os Emails',
            'Todos os Telefones',
            'Telefones Válidos',
            'Decisores',
        ];
        this.decisorFields = [
            'Nome',
            'Empresa',
            'Nível de decisão',
            'E-mail',
            'Link do linkedIn',
        ];
        this.questions = [
            {
                question: 'Quais planos permitem exportação?',
                answer: 'Pro',
            },
            {
                question: 'Qual nível de permissão meu usuário precisa ter?',
                answer: 'Superadministrador ou usuário que possa criar e editar empresas e contatos.',
            },
            {
                question: 'Onde encontrar os dados das empresas?',
                answer: 'No menu superior em Empresas.',
            },
            {
                question: 'Onde encontrar os dados dos decisores?',
                answer: 'No menu superior em Pessoas.',
            },
            {
                question: 'O que acontece se eu exportar 2 vezes a mesma empresa?',
                answer: 'Nosso integrador irá verificar o campo de cnpj e nome da empresa e não exportará caso já esteja no crm.',
            },
        ];
    }
    get tutorialVideoLink() {
        return getVideosCRM('agendor');
    }
    changedOpenModal() {
        this.ocultedToken = true;
    }
    async verifyToken() {
        this.loading = true;
        try {
            await verifyAgendorToken({ token: this.token });
            this.tokenVerified = true;
            this.ocultedToken = true;
            NotificationService.success('Sucesso', 'Seu token foi salvo com sucesso. Agora você pode exportar para o crm!');
        }
        catch (e) {
            NotificationService.error('Error', 'O token selecionado está inválido');
        }
        this.loading = false;
    }
    changeToken() {
        this.token = '';
        this.tokenVerified = false;
    }
};
__decorate([
    Watch('openModal')
], AgendorConfigCard.prototype, "changedOpenModal", null);
AgendorConfigCard = __decorate([
    Component({
        name: 'AgendorConfigCard',
        components: {
            Modal,
            Tooltip,
            CrmCardContent,
        },
    })
], AgendorConfigCard);
export default AgendorConfigCard;
